export const APP_NAME = "My Virgilipsas";

export const TERMS_URL = "https://api.virgilipsas.com/docs/terms.pdf";
